// Code adapted from:
// eslint-disable-next-line max-len
// https://github.com/mui-org/material-ui/blob/master/docs/src/pages/demos/tooltips/CustomizedTooltips.js

import React, {useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Tooltip, {TooltipProps} from '@material-ui/core/Tooltip';
import theme from '../../theme';

export {TooltipProps as ArrowTooltipProps};

function ArrowTooltip({
    classes,
    title,
    ...props
}: TooltipProps & {classes: {popper: string; arrow: string}}) {
    const [arrowRef, setArrowRef] = useState();

    return <Tooltip
        {...props}
        title={
            <React.Fragment>
                {title}
                <span className={classes.arrow} ref={setArrowRef} />
            </React.Fragment>
        }
        classes={{popper: classes.popper, tooltip: classes.tooltip}}
        PopperProps={{
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef,
                    },
                },
            },
        }}
    />;
}

export default withStyles({
    tooltip: {
        position: 'relative',
    },
    popper: {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.95em',
            width: '2em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${theme.palette.grey[700]} transparent`,
            },
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.95em',
            width: '2em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${theme.palette.grey[700]} transparent transparent transparent`,
            },
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.95em',
            height: '2em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.palette.grey[700]} transparent transparent`,
            },
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.95em',
            height: '2em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${theme.palette.grey[700]}`,
            },
        },
    },
    arrow: {
        position: 'absolute',
        fontSize: 6,
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            borderStyle: 'solid',
            width: 0,
            height: 0,
        },
    },
})(ArrowTooltip);
